import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "close",
  "use": "close-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"close\"><path d=\"M24.96 5.333L16 14.293l-8.96-8.96L5.333 7.04l8.96 8.96-8.96 8.96 1.707 1.707 8.96-8.96 8.96 8.96 1.707-1.707-8.96-8.96 8.96-8.96-1.707-1.707z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol